import React, { useState } from "react";

export default function GlitchText({ text, className, onClick }) {
  const [display, setDisplay] = useState(text);

  const handleHover = () => {
    let iterations = 0;
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    const original = text.split("");

    const interval = setInterval(() => {
      setDisplay(
        original
          .map((char, i) =>
            i < iterations ? original[i] : letters[Math.floor(Math.random() * letters.length)]
          )
          .join("")
      );

      if (iterations >= original.length + 5) clearInterval(interval); // extra iterations to glitch longer
      iterations += 0.25; // slower reveal
    }, 50); // slower interval for longer glitch effect
  };

  return (
    <span className={`glitch-text ${className || ""}`} onMouseEnter={handleHover} onClick={onClick}>
      {display}
    </span>
  );
}
